import React from "react";
import { useNavigate } from "react-router-dom";
import MainPresenter from "./MainPresenter";
import { useScrollTop } from '../../hooks';
import { artist } from '../../api';

import ajm from '../../images/ajm/profile/1.jpeg';
import ghe from '../../images/ghe/profile/1.jpg';
import jhs from '../../images/jhs/profile/1.jpg';
import jj from '../../images/jj/profile/1.jpg';
import jjh from '../../images/jjh/profile/1.jpg';
import jns from '../../images/jns/profile/1.jpg';
import kbb from '../../images/kbb/profile/1.jpeg';
// import lhe from '../../images/lhe/profile/1.jpg';
// import lsb from '../../images/lsb/profile/1.jpg';
import lsk from '../../images/lsk/profile/1.png';
// import bej from '../../images/bej/profile/1.jpg';

const mainInitState = [
  { id: 'jhs', name: 'Jung Hye Seon', img: jhs },
  { id: 'ajm', name: 'Ahn Jae Mo', img: ajm },
  // { id: 'lhe', name: 'Lee Hwang Eui', img: lhe },
  { id: 'lsk', name: 'Lee Su Kyung', img: lsk },
  { id: 'kbb', name: 'Kim Bibi', img: kbb },
  // { id: 'lsb', name: 'Lee Sang Bo', img: lsb },
  { id: 'jns', name: 'Jang Nam Su', img: jns },
  { id: 'ghe', name: 'Gil Ha Eun', img: ghe },
  // { id: 'bej', name: 'Bae Eun Ji', img: bej },
  { id: 'jj', name: 'JUNJE', img: jj },
  { id: 'jjh', name: 'Jang Jung Han', img: jjh },
];

const MainContainer = () => {
  const [main, setMain] = React.useState(mainInitState);
  const navigate = useNavigate();

  const navigateToProfile = (id) => { 
    navigate(`/artist/${id}`); 
  }

  const getMain = async () => {
    try {
      const response = await artist.getArtist();
      console.log('[getMain] response.data : ', response.data);
      // setMain(response.data);
    } catch (error) {
      console.error(error);
    }
  };

  React.useEffect(() => {
    // getMain();
  }, []);
  
  useScrollTop();

  return <MainPresenter main={main} navigateToProfile={navigateToProfile} />;
};

export default MainContainer;
